export default "__VITE_ASSET__c6090a6e__"